import React, { useState, useEffect } from "react";
import axios from "axios";
import url from "../../function/url";
import Navbar from "./Navbar";
import ReactPaginate from "react-paginate";
import "../Document/Table.css";
import Swal from "sweetalert2";

const ManagerBlacklist = () => {
  const [blacklistRequests, setBlacklistRequests] = useState([]);
  const [telecallers, setTelecallers] = useState([]);
  const [assignedRequests, setAssignedRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });

  // Fetch blacklist requests
  useEffect(() => {
    axios
      .get(`${url.path}/blacklist-requests/`)
      .then((response) => {
        setBlacklistRequests(response.data);
        // Update assignedRequests with ids of the requests that already have a telecaller assigned
        const assignedIds = response.data
          .filter((request) => request.telecaller_assigned)
          .map((request) => request.id);
        setAssignedRequests(assignedIds);
      })
      .catch((error) => console.error("Error fetching blacklist requests:", error));
  }, []);

  // Fetch telecallers
  useEffect(() => {
    axios
      .get(`${url.path}/get-telecallers/`)
      .then((response) => setTelecallers(response.data))
      .catch((error) => console.error("Error fetching telecallers:", error));
  }, []);

  // Assign telecaller
  const assignTelecaller = (blacklistId, telecallerId) => {
    axios
      .post(`${url.path}/assign-telecaller-to-blacklist/${blacklistId}/`, {
        telecaller_id: telecallerId,
      })
      .then((response) => {
        // alert(response.data.message);
        Toast.fire({
          icon: "success",
          title: "Telecaller assigned successfully!",
        });

        // Update the blacklist request in the state immediately
        setBlacklistRequests((prevRequests) =>
          prevRequests.map((request) =>
            request.id === blacklistId
              ? { ...request, telecaller_assigned: telecallerId }
              : request
          )
        );

        // Update the assignedRequests state
        setAssignedRequests((prevAssigned) => [...prevAssigned, blacklistId]);
      })
      .catch((error) => {
        console.error("Error assigning telecaller:", error);
        Toast.fire({
          icon: "error",
          title: "Failed to assign telecaller.",
        });
        // alert(
        //   error.response?.data?.error ||
        //     "Failed to assign telecaller. Please try again."
        // );
      });
  };

  // Pagination logic
  const offset = currentPage * itemsPerPage;
  const currentItems = blacklistRequests.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(blacklistRequests.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  // JavaScript-based search
  const searchTable = (event) => {
    const searchTerm = event.target.value.trim().toLowerCase();
    const rows = document.querySelectorAll("#blacklistTable tbody tr");

    rows.forEach((row) => {
      const rowText = row.textContent.toLowerCase();
      row.style.display = rowText.includes(searchTerm) ? "" : "none";
    });
  };

  return (
    <>
      <Navbar />
      
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Blacklist Requests
        </h3>
      </center>
      <div className="page-wrapper">
        <div className="input-width">
        <input
          type="text"
          id="search"
          placeholder="Search in table..."
          onInput={searchTable} // Attach the JavaScript-based search function
          className="search-input"
        />
        </div>
      
      </div>
      
      <div className="table-container">
       
        <table id="blacklistTable" className="responsive-table">
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Reason</th>
              <th>Date</th>
              <th>Assign Telecaller</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((request) => (
              <tr key={request.id}>
                <td>{request.employee_name}</td>
                <td>{request.reason}</td>
                <td>
  {request.date ? new Date(request.date).toLocaleDateString() : "N/A"}
</td>

<td>
  <select
    id={`telecaller-select-${request.id}`}
    disabled={assignedRequests.includes(request.id)} // Disable if assigned
    style={{
      padding: "5px",
      borderRadius: "5px",
      border: "1px solid #ccc",
    }}
  >
    <option value="">-- Select Telecaller --</option>
    {telecallers.map((telecaller) => (
      <option key={telecaller.id} value={telecaller.id}>
        {telecaller.Employee_Name}
      </option>
    ))}
  </select>
</td>

<td>
  <button
    onClick={() => {
      const telecallerId = document.getElementById(`telecaller-select-${request.id}`).value;
      if (telecallerId) {
        // Call the function to assign the telecaller
        assignTelecaller(request.id, telecallerId);
        setAssignedRequests((prev) => [...prev, request.id]); // Update assigned requests state
      } else {
        alert("Please select a telecaller before assigning.");
      }
    }}
    disabled={assignedRequests.includes(request.id)} // Disable if already assigned
    style={{
      padding: "8px 12px",
      borderRadius: "5px",
      fontWeight: "bold",
      color: "white",
      backgroundColor: assignedRequests.includes(request.id) ? "green" : "blue",
      border: "none",
      cursor: assignedRequests.includes(request.id) ? "not-allowed" : "pointer",
    }}
  >
    {assignedRequests.includes(request.id) ? "Assigned" : "Assign"}
  </button>
</td>



              </tr>
            ))}
          </tbody>
        </table>
        {blacklistRequests.length > itemsPerPage && (
          <ReactPaginate
            previousLabel={"← Previous"}
            nextLabel={"Next →"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        )}
      </div>
      
    </>
  );
};

export default ManagerBlacklist;
